module.exports = __webpack_public_path__ + "static/img/8.f5ba57b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/8.png
// module id = uCZg
// module chunks = 0